<template>
  <div class="job-title-interest" dir="rtl">
    <div v-if="editable" class="buttons has-addons mb-0">
      <button
        v-for="state in states"
        :key="state"
        type="button"
        class="button is-small job-title-interest-option"
        :class="{ 'is-info is-selected': value === state }"
        :data-state="state"
        :aria-pressed="value === state ? 'true' : 'false'"
        @click="$emit('input', state)"
      >
        {{ label(state) }}
      </button>
    </div>
    <p
      v-else
      class="m-1 is-size-7 job-title-interest-text"
      :class="{ 'has-text-grey': value === 'unknown' }"
      :data-state="value"
    >
      {{ label(value) }}
    </p>
  </div>
</template>

<script>
import { interestLabel } from '@/custom/classes/applicant_job_titles.js'

export default {
  name: 'JobTitleInterest',
  props: {
    value: { type: String, required: true },
    states: { type: Array, required: true },
    editable: { type: Boolean, default: false }
  },
  methods: {
    label (state) {
      return interestLabel(state)
    }
  }
}
</script>
